import { makeStyles, createStyles } from '@material-ui/core/styles'
import { useMediaQueryContext } from 'MediaQueryProvider'
import React, { useEffect } from 'react'
import { moleculeLog } from 'utils/logUtil'
import clsx from 'clsx'

type Props = {
  key?: number
  tab?: number
  label: string
  event: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  disabled?: boolean
}

const useStyles = makeStyles(() =>
  createStyles({
    item: {
      border: '1px solid #000000',
      marginRight: 10,
    },
    centerPosition: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    mobile: {
      border: '2px solid #000000',
    },
  }),
)

/**
 * CSV登録などに使用する水色のボタン
 * @returns
 */
const M_ButtonSubmit = ({ key = 100, tab = -1, label, event, disabled = false }: Props) => {
  useEffect(() => moleculeLog('M_ButtonSubmit'))
  const { isMobileSite } = useMediaQueryContext()
  const classes = useStyles()
  return (
    <>
      {disabled ? (
        <button key={key} tabIndex={tab} style={{ width: 140, backgroundColor: '#DDDDDD' }} className={clsx({ [classes.mobile]: isMobileSite })} onClick={event} disabled>
          {label}
        </button>
      ) : (
        <button key={key} tabIndex={tab} style={{ width: 140, backgroundColor: '#0FF', cursor: 'pointer' }} className={clsx({ [classes.mobile]: isMobileSite })} onClick={event}>
          {label}
        </button>
      )}
    </>
  )
}
export default React.memo(M_ButtonSubmit)
